module.exports = __webpack_public_path__ + "media/images/logo_p4-bd0f9be556d3044262004526d17cb0d2.svg";